import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { setupStore } from "./app/store";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import LocalizationWrapper from "./components/common/LocalizationWrapper";

const container = document.getElementById("root")!;
const root = createRoot(container);

const store = setupStore();
let persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <LocalizationWrapper>
        <App />
      </LocalizationWrapper>
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
